import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Event, GiftCard, Land, LikeCollection, Post, Sharry, User, Wonder } from 'src/types/graphql';
import { ContentTypeColorizerService } from '../services/content-type-colorizer.service';

@Pipe({
  name: 'colorize',
  standalone: true,
})
export class ContentTypeColorizerPipe implements PipeTransform {
  constructor(
    private sanitized: DomSanitizer,
    private contentTypeColorizerService: ContentTypeColorizerService,
  ) {}

  transform(
    value: Partial<Sharry | Wonder | Event | LikeCollection | User | Post | GiftCard | Land>,
    type: 'short' | 'long' = 'long',
  ): SafeHtml {
    if (!value) return '';
    const { color, text } = this.contentTypeColorizerService.colorize(value, type);
    const span = `<span style="color: ${color}; display: block">${text}</span>`;
    return this.sanitized.bypassSecurityTrustHtml(span);
  }
}
